import type { CSSObject } from '@emotion/react'
import { Spacing } from '@opallabs/gem'

export const labelOverrides: CSSObject = {
  marginTop: Spacing.L,
}

export const textAreaOverrides: CSSObject = {
  width: '100%',
}

export const checkboxOption: CSSObject = {
  display: 'flex',
  columnGap: `${Spacing.S * 1.5}px`,
  alignItems: 'center',
}
